export const getUrlParams = (params) => {
  if (!params) return undefined
  const url = new URL(window.location.href)
  const search = Array.isArray(params) ? params : [params]
  const found = search.map((p) => url.searchParams.get(p))
  return found.length === 1 ? found[0] : found
}

export const padZero = (num) => num.toString().padStart(2, '0')

export const getDateObj = (dateStr) => {
  const [day, month, year] = dateStr.split('/')
  return new Date(year, month - 1, day)
}

export const getDateString = (dateObj) => {
  const day = padZero(dateObj.getDate())
  const month = padZero(dateObj.getMonth() + 1)
  const year = dateObj.getFullYear()
  return `${day}/${month}/${year}`
}

export const formatEuro3Decimals = (value) => formatMoney3Decimals(value)

/**
 * Un importo con almeno tre decimali, nella valuta in cui è stato calcolato.
 *
 * Il costo di un turno del motore agentico è una frazione di centesimo, e il listino del
 * modello può essere in dollari: mostrarlo con il simbolo dell'euro sarebbe un dato
 * sbagliato, non una formattazione approssimativa. Senza valuta si resta sull'euro, che è
 * quella in cui conta il motore legacy.
 *
 * @param {number} value Importo
 * @param {string} [valuta] Codice ISO della valuta (`EUR`, `USD`)
 * @returns {string} Importo formattato, stringa vuota se non c'è nulla da mostrare
 */
export const formatMoney3Decimals = (value, valuta) => {
  if (!value) return ''
  const firstDecimal =
    value
      ?.toString()
      ?.split('.')[1]
      ?.split('')
      ?.findIndex((d) => d !== '0') || 0
  const simbolo = valuta === 'USD' ? '$' : '€'
  return value?.toFixed(Math.max(firstDecimal + 1, 3))?.replace('.', ',') + ' ' + simbolo
}
